export default __webpack_public_path__ + "static/media/gallery-wip-handle_00.bc38ca50.jpg";